import { LOG_LEVELS, SendLog } from "./log";

export type ErrorMessageMap = { [key: number]: string };

export const createErrorHandler =
  (
    errorMessages: ErrorMessageMap,
    getMessagePrefix: (status: number) => string = () => "",
  ) =>
  async ({
    status,
    url,
    eventName,
  }: { status: number; url?: string; eventName?: string }): Promise<void> => {
    try {
      const errorMessage = errorMessages[status] || `Error ${url}`;
      const eventPrefix = eventName ? `${eventName} | ` : "";
      const message = `${eventPrefix}${getMessagePrefix(status)}${errorMessage}, ${url}`;
      console.error(message);
      await SendLog(LOG_LEVELS.ERROR, message);
    } catch {
      console.error();
    }
  };
